import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography } from '@mui/material';

const RefundPolicy = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ my: 4, px: 2 }}>
      {/* Back Button */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 3 }}>
        <Button variant="contained" onClick={() => navigate(-1)}>
          ← Back
        </Button>
      </Box>

      {/* Title and Last Updated */}
      <Typography variant="h3" component="h1" gutterBottom>
        Refund Policy
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        <strong>Last Updated:</strong> 31.03.2025
      </Typography>

      {/* Introduction */}
      <Typography variant="body1">
        Thank you for subscribing to Medicheck. We strive to ensure our subscribers have a positive experience with our service. Please review our refund policy carefully to understand our terms clearly.
      </Typography>

      {/* Subscription and Refund Eligibility */}
      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Subscription and Refund Eligibility
      </Typography>
      <Typography variant="body1">
        Medicheck offers a monthly subscription-based service providing pharmacists and pharmacy businesses access to detailed medicine information, similar medicines, brands, and side-effect information. As a purely digital service, subscriptions are generally non-refundable once the service has been accessed.
      </Typography>
      <Typography variant="body1">
        However, we offer refunds exclusively in the following cases:
      </Typography>

      {/* Billing Errors */}
      <Typography variant="body1" sx={{ mt:2, mb: 1 }}>
        1. <strong>Billing Errors</strong>
      </Typography>
      <Typography variant="body1" sx={{ pl: 2 }}>
        If you have been incorrectly billed (e.g., duplicate billing or incorrect subscription amount charged), please contact our support team immediately. Upon verification, we will process a refund for the incorrectly billed amount.
      </Typography>

      {/* Technical Issues Preventing Access */}
      <Typography variant="body1" sx={{ mt:2, mb: 1 }}>
        2. <strong>Technical Issues Preventing Access</strong>
      </Typography>
      <Typography variant="body1" sx={{ pl: 2 }}>
        If you experience technical issues caused by Medicheck that completely prevent access to the subscribed service for a significant duration (at least 48 consecutive hours) and we are unable to resolve the issue within a reasonable time, you may be eligible for a full or partial refund for that month.
      </Typography>

      {/* How to Request a Refund */}
      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        How to Request a Refund
      </Typography>
      <Typography variant="body1">
        To request a refund, please contact our support team at support@medicheck.lk
      </Typography>
      <Typography variant="body1">
        Include the following details:
      </Typography>
      <Typography variant="body1" sx={{ pl: 2, mb: 1, mt:1 }}>
        - Your full name
      </Typography>
      <Typography variant="body1" sx={{ pl: 2, mb: 1, mt:1 }}>
        - Registered email address
      </Typography>
      <Typography variant="body1" sx={{ pl: 2, mb: 1, mt:1 }}>
        - Description of the billing error or technical issue
      </Typography>
      <Typography variant="body1" sx={{ pl: 2, mb: 1, mt:1 }}>
        - Proof of billing such as transaction details or payment confirmation.
      </Typography>
      <Typography variant="body1">
        We will review your request within 3-5 business days and inform you of our decision. Approved refunds will be processed back to the original payment method used during the subscription.
      </Typography>

      {/* Subscription Cancellation and Account Deletion */}
      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Subscription Cancellation and Account Deletion
      </Typography>
      <Typography variant="body1">
        You may cancel your Medicheck subscription at any time. Cancellation and account deletion will prevent future charges but will not entitle you to a refund for the current billing cycle.
      </Typography>

      {/* Changes to This Refund Policy */}
      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Changes to This Refund Policy
      </Typography>
      <Typography variant="body1">
        We reserve the right to update this Refund Policy at any time. Any changes will be clearly posted on our website along with the revised "Last Updated" date. Your continued use of Medicheck after any changes indicates your acceptance of the revised Refund Policy.
      </Typography>

      {/* Contact Us */}
      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Contact Us
      </Typography>
      <Typography variant="body1">
        If you have any questions or need assistance regarding this policy, please contact us:
      </Typography>
      <Typography variant="body1">
        - <strong>Email:</strong> support@medicheck.lk
      </Typography>
    </Container>
  );
};

export default RefundPolicy;
